import cn from 'classnames/bind';
import {
  Container, Row, Col, Button,
} from 'ui';

import s from './JoinUsSection.module.scss';

const cx = cn.bind(s);

const JoinUsSection = ({
  title = 'Keen to meet your inner self?',
  buttonText = 'Take the test now!',
  href = '/free-personality-test',
  subTitle = 'Find out your personality type and unlock your hidden potential with our free personality test!',
  children,
  className,
  ...attrs
}) => (
  <section className={cx(className, 'wrapper')} {...attrs}>
    <Container className={cx('container')}>
      <Row>
        <Col xs={12} md={{ offset: 1, span: 10 }} lg={{ offset: 2, span: 8 }}>
          <h2 className={cx('title', 'tp-mobile-cta-block md:tp-tablet-header-2 lg:tp-header-2')}>
            {title}
          </h2>
          {subTitle && (
            <p className={cx('subtitle', 'text-[20px] leading-[27px]')}>
              {subTitle}
            </p>
          )}
          <Button
            as="a"
            href={href}
            className={cx('btn')}
            color="white"
          >
            {buttonText}
          </Button>
        </Col>
      </Row>
    </Container>
  </section>
);

export default JoinUsSection;
